export default __webpack_public_path__ + "static/media/linkedin.3313cdc5.svg";